export const exportBankReportToCSV = (bankReportPDFData,orgInitials) => {
    // Define CSV headers
    const headers = [
        "SL No.",
        "Employee Code",
        "Employee Name",
        "Bank Name",
        "Branch Name",
        "Account Number",
        "IFSC Code",
        "Payment Through (NEFT/IMPS)",
        "Net Pay",
    ];
    const csvData = bankReportPDFData.map((employee, index) => {
        // Find branch name
        //   const branchName = employee?.branch_id
        //     ? branchList?.find(branch => branch?.id === employee?.branch_id)?.name || "--"
        //     : "--";

        return [
            index + 1,
            employee?.employees?.employee_code ? employee?.employees?.employee_code : "--",
            employee?.employee_name ? employee?.employee_name : "--",
            employee?.employees?.bank_name ? employee?.employees?.bank_name : "--",
            employee?.employees?.branch_name ? employee?.employees?.branch_name : "--",
            employee?.employees?.account_number ? employee?.employees?.account_number : "--",
            employee?.employees?.ifsc_code ? employee?.employees?.ifsc_code : "--",
            // employee?.join_date ? new Date(employee?.join_date).toLocaleDateString() : "--",
            employee?.employees?.payment_through ? employee?.employees?.payment_through : "--",
            employee?.payable_salary ? employee?.payable_salary : "--",
            // employee?.guardian_name || "--",
            // employee?.salary_type ? employee?.salary_type.toUpperCase() : "--",
            // employee?.esic_insurance_number || "--",
            // employee?.uan_no || "--",
            // employee?.salary_info?.gross_salary ? `₹${employee?.salary_info?.gross_salary.toFixed(2)}` : "₹0.00",
            // employee?.benefits?.ot_rate ? `₹${employee?.benefits?.ot_rate.toFixed(2)}` : "₹0.00"
        ];
    });

    // Combine headers and data
    const csvContent = [
        headers.join(","),
        ...csvData.map(row => row.map(cell => {
            // If the cell contains a comma, wrap it in quotes
            return cell.toString().includes(",") ? `"${cell}"` : cell;
        }).join(","))
    ].join("\n");

    // Create a Blob with the CSV data
    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });

    // Create a temporary download link
    const link = document.createElement("a");
    const url = URL.createObjectURL(blob);

    // Set the file name
    // const fileName = `${orgInitials}-Employee-List.csv`;
    const fileName = `Pay_Acquiescent_Report_${orgInitials}.csv`;


    // Configure and trigger download
    link.setAttribute("href", url);
    link.setAttribute("download", fileName);
    link.style.visibility = "hidden";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
};